import { Skeleton } from "@mui/material";

export function UserAvatarSkeleton({ size = 40, sx }) {
  return (
    <Skeleton
      variant="circular"
      width={size}
      height={size}
      animation="wave"
      sx={sx}
    />
  );
}

export function UserNameSkeleton({ width = 120, height = 20, sx }) {
  return (
    <Skeleton
      variant="text"
      width={width}
      height={height}
      animation="wave"
      sx={sx}
    />
  );
}
